import script from "./CardInvoiceTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./CardInvoiceTable.vue?vue&type=script&setup=true&lang=ts"

import "./CardInvoiceTable.vue?vue&type=style&index=0&id=89cb2f28&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-89cb2f28"]])

export default __exports__